/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const SaveAs = (props: IconProps) => (
  <Icon {...props}>
    <path d="M21 12.4V7L17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H12.4L21 12.4ZM15 15C15 16.66 13.66 18 12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15ZM6 6H15V10H6V6ZM19.99 16.25L21.76 18.02L16.77 23H15V21.23L19.99 16.25ZM23.25 16.51L22.4 17.36L20.63 15.59L21.48 14.74C21.68 14.54 21.99 14.54 22.19 14.74L23.25 15.8C23.45 16 23.45 16.32 23.25 16.51Z" />
  </Icon>
);
